import { eTipoPermissao } from "@/enums/ePermissoes";

const permissions = [eTipoPermissao.CONTRATONOVO_MENU_1900400299];

export default [
 {
  description: "Contrato",
  path: "/merenda/mercontrato",
  name: "mercontrato",
  component: () => import("@/views/merenda/mercontrato/Index.vue"),
  meta: {
   permissions,
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Contrato",
  path: "/merenda/mercontrato/cadastro/:id?",
  parent: "mercontrato",
  name: "mercontrato_create",
  component: () => import("@/views/merenda/mercontrato/InclusaoEdicao.vue"),
  meta: {
   permissions,
  },
  goesToMenu: true,
 },
 {
  description: "Dotacao Orcamentaria do Contrato",
  path: "/merenda/mercontrato/:merContratoId/dotacaoorcamentaria",
  parent: "mercontrato",
  name: "mercontrato_dotacaoorcamentaria",
  component: () => import("@/views/merenda/merdotacaoorcamentaria/CadastroComGrid.vue"),
  meta: {
   permissions,
  },
  goesToMenu: false,
 },
 {
  description: "Empenho do Contrato",
  path: "/merenda/mercontrato/:merContratoId/empenho",
  parent: "mercontrato",
  name: "mercontrato_empenho",
  component: () => import("@/views/merenda/merempenho/CadastroComGrid.vue"),
  meta: {
   permissions,
  },
  goesToMenu: false,
 },
 {
  description: "Quantitativo do Contrato",
  path: "/merenda/mercontrato/:merContratoId/quantitativo",
  parent: "mercontrato",
  name: "mercontrato_quantitativo",
  component: () => import("@/views/merenda/mercontrato/Itens.vue"),
  meta: {
   permissions,
  },
  goesToMenu: false,
 },
]
